var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop-coupon"},_vm._l((_vm.lotteryCode),function(item,index){return _c('div',{key:index,staticClass:"pop-coupon-number"},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }